import React from 'react'
import PropTypes from 'prop-types'
import { Div } from 'glamorous'

import Button from 'components/common/Button'

const ModalButton = props => {
  const { title, onClick } = props

  return (
    <Div
      borderTop="1px solid #dbdce0"
      display="flex"
      flexDirection="column"
      alignItems="stretch"
      justifyContent="center"
      height={46}
    >
      <Button onClick={onClick} css={{ fontSize: 18 }}>{title}</Button>
    </Div>
  )
}

ModalButton.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func
}

ModalButton.defaultProps = {
  onClick: () => {}
}

export default ModalButton



// WEBPACK FOOTER //
// ./src/components/modal/ModalButton.js